import React, { useEffect, useMemo } from 'react';
import { Typography } from 'seagull';
import { useStore, useStoreActions } from "../../../contexts";
import { selectors } from "../../../store/state-selectors";
import GraphWidgetLayout from "../GraphWidget/GraphWidgetLayout";
import AgreementPipelineTopCard from "../AgreementPipelineWidget/AgreementPipelineTopCard";
import GraphWidgetBottomCard from "../GraphWidget/GraphWidgetBottomCard";
import GraphWidgetSuccessState from "../GraphWidget/GraphWidgetSuccessState";
import { getInvoicesWidgetData, chartDataForLoading } from "./InvoicesWidget.utils";
import InvoicesChart from "./InvoicesChart";
import styles from "../VendorDashboard.module.scss";
import VendorDashboardSeeWhatItsLike from "../VendorDashboardSeeWhatItsLike";
import { utils } from "../../../utils";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
export default function InvoicesWidget() {
  const businessId = useStore(selectors.user.businessId);
  const invoices = useStore(state => state.invoices);
  const {
    fetchInvoicesAndCounters
  } = useStoreActions();
  const {
    USE_INVOICE_VIEWS = false
  } = useFeatureFlags();
  useEffect(() => {
    if (businessId) {
      fetchInvoicesAndCounters(USE_INVOICE_VIEWS);
    }
  }, [businessId, USE_INVOICE_VIEWS]);
  const data = useMemo(() => {
    return getInvoicesWidgetData(invoices.data);
  }, [invoices.data]);
  const allExpectedToBePaid = data && data.totals.requireAttention.count === 0 && data.totals.expectedToBePaid.count > 0;
  return /*#__PURE__*/React.createElement(GraphWidgetLayout, {
    title: "Invoices pipeline",
    loading: !!data && invoices.loading
  }, /*#__PURE__*/React.createElement(AgreementPipelineTopCard, {
    title: "Require attention",
    cornerText: data === null || data === void 0 ? void 0 : data.totals.requireAttention.count,
    primaryText: (data === null || data === void 0 ? void 0 : data.totals.requireAttention.total) != null ? utils.formatDollarAmount(data === null || data === void 0 ? void 0 : data.totals.requireAttention.total) : undefined,
    info: "The value of invoices that will not be processed without intervention",
    testid: "invoices-widget-card-requireAttention"
  }), /*#__PURE__*/React.createElement(AgreementPipelineTopCard, {
    success: true,
    title: "Expected to be paid",
    cornerText: data === null || data === void 0 ? void 0 : data.totals.expectedToBePaid.count,
    primaryText: (data === null || data === void 0 ? void 0 : data.totals.expectedToBePaid.total) != null ? utils.formatDollarAmount(data === null || data === void 0 ? void 0 : data.totals.expectedToBePaid.total) : undefined,
    info: "The value of invoices being processed that will be paid automatically",
    testid: "invoices-widget-card-expectedToBePaid"
  }), /*#__PURE__*/React.createElement(GraphWidgetBottomCard, {
    "data-testid": "invoices-widget-card-chart",
    empty: !!invoices.data && !invoices.data.length,
    emptyMsg: /*#__PURE__*/React.createElement("div", {
      className: styles.emptyStateWithAction
    }, /*#__PURE__*/React.createElement(Typography, null, "Here you will see your invoices"), /*#__PURE__*/React.createElement(VendorDashboardSeeWhatItsLike, {
      "data-testid": "invoices"
    })),
    loading: !data,
    loadingMsg: "Loading your invoices",
    loadingOrEmptyBg: () => /*#__PURE__*/React.createElement(InvoicesChart, {
      chartData: chartDataForLoading
    }),
    error: invoices.error && !invoices.loading,
    onRefresh: () => fetchInvoicesAndCounters(USE_INVOICE_VIEWS)
  }, allExpectedToBePaid ? /*#__PURE__*/React.createElement(GraphWidgetSuccessState, {
    title: "Put your feet up!",
    body: "All your invoices are expected to be paid"
  }) : data && /*#__PURE__*/React.createElement(InvoicesChart, {
    chartData: data.chart,
    testid: "invoices-widget-chart"
  })));
}